import { useState, useEffect } from "react";

const BrowserOnly = (props) => {
  const [shouldRender, setShouldRender] = useState(false);
  useEffect(() => {
    setShouldRender(true);
  }, []);
  if (!shouldRender) return props.placeholder || null;
  return props.children;
};

export default BrowserOnly;
